
import { Component, Mixins } from "vue-property-decorator";
import { ITableSize } from "../../../../../../documaker/domain/format/objects";
import { ITableSizePropertyEditable, instanceOfITableSizePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TableSizePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITableSizePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITableSizePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTableSizeEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITableSizePropertyEditable(s) && s.tableSize().isEditable(), false);
  }

  get tableSize(): ITableSize {
    return this.readPropertyOrDefault(s => s.tableSize().getValue(), { row: 1, column: 1 });
  }

  set tableSize(value: ITableSize) {
    this.writePropertyWhenValid(s => s.tableSize().setValue(value));
  }
}
